/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Span
import systems.frictionless.impulse.browser.style.support.FontStyle
import systems.frictionless.impulse.browser.style.support.FontWeight
import systems.frictionless.impulse.browser.style.support.fontStyle
import systems.frictionless.impulse.browser.style.support.fontWeight

/**
 * Wrapper around [org.jetbrains.compose.web.dom.Text] with simplified styling.
 */
@Composable
fun Text(
    value: String,
    fontWeight: FontWeight? = null,
    fontStyle: FontStyle? = null,
    classes: Array<String> = emptyArray()
) {
    Span(
        attrs = {
            classes.forEach {
                this.classes(it)
            }
            style {
                fontWeight?.let {
                    fontWeight(fontWeight)
                }
                fontStyle?.let {
                    fontStyle(fontStyle)
                }
            }
        }
    ) {
        org.jetbrains.compose.web.dom.Text(value = value)
    }
}
